import { getProductListEdoc } from '@/api/pc-api/v1/product/list/edoc';
import { getProductListMyData } from '@/api/pc-api/v1/product/list/mydata';
import { getProductListSet4 } from '@/api/pc-api/v1/product/list/set4';
import { BizType } from '@/constants/bizType';

export const getProductList = (bizType: BizType | null, isTest?: boolean) => {
  switch (bizType) {
    case BizType.SET4:
      return getProductListSet4(isTest);
    case BizType.EDOC:
      return getProductListEdoc(isTest);
    case BizType.MYDATA_CORP:
    case BizType.MYDATA_PROVIDER:
      return getProductListMyData(isTest);
    default:
      throw Error;
  }
};
